import React, { useState } from "react";
import "./GeographyExplorer.css";

const levels = {
  world: [
    { name: "India", position: { top: "60%", left: "70%" } },
    { name: "USA", position: { top: "30%", left: "20%" } },
    { name: "Eiffel Tower", position: { top: "40%", left: "55%" } },
  ],
  europe: [
    { name: "France", position: { top: "50%", left: "50%" } },
    { name: "Germany", position: { top: "45%", left: "55%" } },
    { name: "Italy", position: { top: "60%", left: "55%" } },
  ],
  india: [
    { name: "Delhi", position: { top: "20%", left: "50%" } },
    { name: "Mumbai", position: { top: "70%", left: "40%" } },
    { name: "Kolkata", position: { top: "40%", left: "80%" } },
  ],
  usa: [
    { name: "New York", position: { top: "20%", left: "80%" } },
    { name: "California", position: { top: "70%", left: "10%" } },
    { name: "Texas", position: { top: "60%", left: "40%" } },
  ],
};

export default function GeographyExplorer() {
  const [mode, setMode] = useState("world");
  const [placed, setPlaced] = useState([]);
  const [score, setScore] = useState(0);
  const [message, setMessage] = useState("");

  // Sounds
  const correctSound = new Audio("/sounds/correct.mp3");
  const wrongSound = new Audio("/sounds/wrong.wav");
  const winSound = new Audio("/sounds/win.mp3");

  const handleDrop = (item) => {
    if (!placed.includes(item.name)) {
      setPlaced([...placed, item.name]);
      setScore(score + 10);
      setMessage(`🎉 Correct! You placed ${item.name}`);
      correctSound.play();
      if (placed.length + 1 === levels[mode].length) {
        setMessage("🏆 All items placed! Final Score: " + (score + 10));
        winSound.play();
      }
    } else {
      setScore(score - 5);
      setMessage("❌ Already placed!");
      wrongSound.play();
    }
  };

  const resetGame = (newMode) => {
    setMode(newMode);
    setPlaced([]);
    setScore(0);
    setMessage("");
  };

  const progress = (placed.length / levels[mode].length) * 100;

  return (
    <div className="geo-container">
      <h1>🗺️ Geography Explorer</h1>
      <div className="mode-buttons">
        <button onClick={() => resetGame("world")}>🌍 World Map</button>
        <button onClick={() => resetGame("europe")}>🇪🇺 Europe Map</button>
        <button onClick={() => resetGame("india")}>🇮🇳 India States</button>
        <button onClick={() => resetGame("usa")}>🇺🇸 USA States</button>
      </div>
      <p className="score">⭐ Score: {score}</p>

      {/* Progress Bar */}
      <div className="progress-bar">
        <div className="progress-fill" style={{ width: `${progress}%` }}></div>
      </div>

      <div className={`map ${mode}`}>
        {levels[mode].map((item, i) => (
          <div
            key={i}
            className={`drop-zone ${placed.includes(item.name) ? "placed" : ""}`}
            style={item.position}
            onDragOver={(e) => e.preventDefault()}
            onDrop={() => handleDrop(item)}
          >
            {placed.includes(item.name) ? item.name : "❓"}
          </div>
        ))}
      </div>
      <div className="items">
        {levels[mode].map((item, i) => (
          <div
            key={i}
            className="draggable"
            draggable
            onDragStart={(e) => e.dataTransfer.setData("text", item.name)}
          >
            {item.name}
          </div>
        ))}
      </div>
      <p className="status">{message}</p>
    </div>
  );
}
